import { useFieldArray } from 'react-final-form-arrays';
import { useCallback } from 'react';

import { useCanEditFormFieldsContext } from '@occc-app/App/CanEditFormFieldsContext';
import { surveysInitialFormValues } from './constants';
import { SurveysFormArrayItem } from './SurveysFormArrayItem';

import { SurveysFormValues, AudienceFormValues } from '../../types';
import { AddAnotherItem } from '../AddAnotherItem';

export type SurveysFormContentProps = {
  name: keyof AudienceFormValues;
};

export const SurveysFormContent = ({ name }: SurveysFormContentProps) => {
  const { fields } = useFieldArray<SurveysFormValues>(name, {
    subscription: {
      length: true,
    },
  });

  const handleAddItem = useCallback(() => fields.push(surveysInitialFormValues), [fields]);
  const handleRemoveItem = useCallback((index: number) => fields.remove(index), [fields]);

  const { isEditable } = useCanEditFormFieldsContext();
  const isDeleteIconShown = isEditable && Boolean(fields.length && fields.length > 1);

  return (
    <>
      {fields.map((fieldName, index) => {
        return (
          <SurveysFormArrayItem
            key={fieldName}
            index={index}
            fieldNamePrefix={fieldName}
            isDeleteIconShown={isDeleteIconShown}
            onDeleteClick={handleRemoveItem}
          />
        );
      })}

      <AddAnotherItem title='Add Another Survey' onClick={handleAddItem} />
    </>
  );
};
